import { COLORS } from "./constants";
import type { CandleWithFlag } from "./types";

export function drawHistogram(
  ctx: CanvasRenderingContext2D,
  dataArr: CandleWithFlag[],
  startIndex: number,
  visibleCount: number,
  left: number,
  candleWidth: number,
  priceToY: (price: number) => number,
  animatedValues: Map<number, { close: number; high: number; low: number }>,
) {
  const barWidth = Math.max(2, candleWidth * 0.3);
  const tickWidth = Math.max(4, candleWidth * 0.35);

  for (let i = 0; i < visibleCount; i++) {
    const dataIndex = startIndex + i;
    if (dataIndex >= dataArr.length) continue;

    const candle = dataArr[dataIndex];
    if (!candle || !("open" in candle) || !("close" in candle)) continue;

    const isUp = candle.close >= candle.open;
    const x = Math.round(left + (i + 0.5) * candleWidth) + 0.5;

    let highPrice = candle.high;
    let lowPrice = candle.low;
    let openPrice = candle.open;
    let closePrice = candle.close;

    const animated = animatedValues.get(dataIndex);
    if (animated) {
      highPrice = animated.high;
      lowPrice = animated.low;
      closePrice = animated.close;
    }

    const color = isUp ? COLORS.up : COLORS.down;
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(1, barWidth);

    ctx.beginPath();
    ctx.moveTo(x, priceToY(highPrice));
    ctx.lineTo(x, priceToY(lowPrice));
    ctx.stroke();

    ctx.lineWidth = barWidth;

    ctx.beginPath();
    ctx.moveTo(x - tickWidth, priceToY(openPrice));
    ctx.lineTo(x + barWidth / 2 - 0.4, priceToY(openPrice));
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(x - (barWidth / 2 - 0.4), priceToY(closePrice));
    ctx.lineTo(x + tickWidth, priceToY(closePrice));
    ctx.stroke();
  }
}
